<div class="main-container">
  <mat-card appearance="outlined">
    <mat-card-title>Available downloads</mat-card-title>
    <mat-card-content class="card-body">
      <mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="time">
          <mat-header-cell *matHeaderCellDef> Date</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.time | date:'short'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="url">
          <mat-header-cell *matHeaderCellDef> Link</mat-header-cell>
          <mat-cell *matCellDef="let element"><a href="{{element.url}}">Download</a></mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </mat-card-content>
  </mat-card>
</div>
